/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlarmPlus: {
  name: 'alarm-plus';
  data: string;
} = {
  name: 'alarm-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.555 2.832a1 1 0 0 0-1.11-1.664l-3 2a1 1 0 1 0 1.11 1.664l3-2Zm10.613-1.387a1 1 0 0 1 1.387-.277l3 2a1 1 0 0 1-1.11 1.664l-3-2a1 1 0 0 1-.277-1.387ZM12 5a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 13C2 7.477 6.477 3 12 3s10 4.477 10 10-4.477 10-10 10S2 18.523 2 13Zm10-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
